<script>
    import ParticleEffect from './particle-effect'

    export default {
        props: {
            text: {
                type: String,
                default: '',
            },
            status: {
                type: String,
                default: '',
            },
            hidden: {
                type: Boolean,
                default: false,
            },
            animating: {
                type: Boolean,
                default: false,
            },
            buttonStyles: {
                type: Object,
                default: null,
            },
            buttonOptions: {
                type: Object,
                default: null,
            },
        },
        computed: {
            particleEffectProps() {
                const result = {hidden: this.hidden}

                Object.keys(this.buttonOptions).forEach(key => {
                    if (key === 'hidden') return

                    result[key] = this.buttonOptions[key]
                })

                return result
            },
            nativeButtonStyles() {
                const result = {
                    background: '#121019',
                    color: '#fff',
                    padding: '0.5rem 1.5rem',
                    border: '0',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '14px',
                }

                Object.keys(this.buttonStyles).forEach(key => {
                    result[key] = this.buttonStyles[key]
                })

                return result
            },
        },
        methods: {
            onAnimationComplete() {
                this.$emit('update:animating', false)
            },
            onToggle() {
                this.$emit('onSubmit', this.status,(res) => {
                    if (!res) {
                        if (this.animating) return
                        this.$emit('update:hidden', !this.hidden)
                        this.$emit('update:animating', true)
                        setTimeout(() => {
                            this.$message({
                                message: '提交成功！',
                                type: 'success'
                            })
                            this.$router.push({
                                path: '/rms/archives',
                            })
                        }, 2000)
                    }
                })

            },
        },
        render(createElement) {
            return createElement(
                ParticleEffect,
                {
                    props: this.particleEffectProps,
                    on: {
                        complete: this.onAnimationComplete,
                    },
                },
                [
                    createElement(
                        'div',
                        {
                            style: this.nativeButtonStyles,
                            on: {
                                click: this.onToggle,
                            },
                        },
                        this.text
                    ),
                ]
            )
        },
    };
</script>
